<template>
    <div>
        <!-- Filtros -->
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <!-- Periodo -->
                    <div class="col col-12 col-md-2">
                        <az-input   
                            icon="fa-solid fa-greater-than-equal fa-fw"
                            type="date"
                            v-model="referencia" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input   
                            icon="fa-solid fa-less-than-equal fa-fw"
                            type="date"
                            v-model="referencia_final" />
                    </div>
                    <div class="col col-3 col-md-3">
                        <az-input
                            type="select"
                            required
                            :optionsList="terceiros"
                            optionsData="id_terceiro"
                            optionsDisplay="search"
                            v-model="id_terceiro"
                        />
                    </div>

                    <div class="col col-12 col-md-3" v-if="!( selecionado && selecionado.st_classe == 'terceiroKlis' )">
                        <az-submit color="primary" @click="load()">Importar resultados</az-submit>
                    </div>

                    <template v-else>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="far fa-building fa-fw"
                                type="select"
                                placeholder="Unidade..."
                                :optionsList="$util.unidades_com_tags(false, true)"
                                optionsData="id_unidade_operacao"
                                v-model="filtros.id_unidade_operacao" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select"
                                icon="fa-solid fa-code fa-fw"
                                placeholder="Layout Padrão"
                                :optionsList="[
                                    { id: 'smart', search: 'Padrão Smart' }
                                ]"
                                optionsData="id" 
                                v-model="filtros.padrao" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- Fim Header -->

        <div class="progress mt-1 mb-3">
            <div
                class="indeterminate"
                v-if="$store.state.loading && dados"
            ></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="selecionado && selecionado.st_classe == 'terceiroKlis'" class="mb-3">
            <az-submit color="primary" :disabled="!filtros.id_unidade_operacao" @click="exportar_klis()">Exportar Resultados</az-submit>
        </div>

        <div v-else>

            <div v-if="!dados">
                <az-empty-state
                    icon="fas fa-vials"
                    msg="Nenhum resultado identificado."
                />
            </div>

            <template v-else>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Atendimento/Exame</th>
                            <th>Data</th>
                            <th>Paciente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(resultado, ilx) in dados.resultados" :key="ilx">
                            <td
                                style="width: 35%"
                                :class="
                                    resultado.importado
                                        ? 'text-success'
                                        : 'text-danger'
                                "
                            >
                                {{ resultado.mensagem }}
                            </td>
                            <td style="width: 15%">
                                {{ resultado.codigo }}
                            </td>
                            <td>
                                <template v-if="resultado.data_marcacao">
                                    {{
                                        $util.getFormatDate(
                                            resultado.data_marcacao,
                                            "DD/MM/YYYY",
                                            false
                                        )
                                    }}
                                </template>
                            </td>
                            <td>
                                <template v-if="resultado.nome_paciente">
                                    {{ resultado.nome_paciente }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>

        </div>
        
        <!-- Dispatch -->
        <az-dispatch
            ref="dispatchModal"
            name="dispatchModalResultadosLote"
            titulo="Importando resultados..."
            @chunkRefresh="refresh_chunk" 
            @chunkFinal="final_chunk" 
        />
    </div>
</template>

<script>
// import _ from "lodash";
// import $ from "jquery";
import * as moment from "moment";
import AzInput from "../../shared/forms/AzInput.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzDispatch from "../../util/AzDispatch.vue";

export default {
    data() {
        return {
            dados: null,
            referencia: this.$util.getDataDias("-7"),
            referencia_final: this.$util.hoje(),
            id_terceiro: "",
            search: "",
            agora: null,
            edicao: null,
            terceiros: [],
            marcacoes: [],
            stopChunkMarcacoes: false,
            filtros: { 
                id_unidade_operacao: "", 
                id_apoiado: "", 
                padrao: "", 
            }
        };
    },

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzDispatch
    },

    computed: { 
        selecionado: function () {
            if ( !this.id_terceiro )
                return null; 

            return this.terceiros.find(terceiro => terceiro.id_terceiro == this.id_terceiro);
        }
    },

    methods: {
        exportar_klis () { 
            
            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'exportar_klis',
                redir_api: true, 
                dados: { 
                    inicio: this.referencia,
                    fim: this.referencia_final,
                    ...this.filtros, 
                },
                toast: true,
                callback: res => { 

                    // Create a URL for the Blob
                    let type = 'application/json';

                    if ( this.filtros.padrao == 'smart' ) { 
                        type = 'application/xml';
                    }
                    
                    const blob = new Blob([res], { type: type });
                    const url = window.URL.createObjectURL(blob);

                    // Create a temporary link element
                    const link = document.createElement('a');
                    link.href = url;

                    if ( this.filtros.padrao == 'smart' ) { 
                        link.download = 'resultados.xml'; // File name for the downloaded file
                    } else { 
                        link.download = 'resultados.json';
                    }

                    // Programmatically click the link to trigger the download
                    document.body.appendChild(link);
                    link.click();

                    // Clean up the temporary URL and element
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                }

            });

        },

        load() {
            this.dados = null;
            this.marcacoes = [];
            this.stopChunkMarcacoes = false;
            
            // criar um array de datas começando pela referencia e terminando na referencia_final
            let datas = [];
            let data = moment(this.referencia);
            let data_final = moment(this.referencia_final);
            while (data <= data_final) {
                datas.push({
                    id_terceiro: this.id_terceiro,
                    referencia: data.format("YYYY-MM-DD"),
                    referencia_final: data.format("YYYY-MM-DD")
                });
                data.add('1', 'days');
            }
            
            this.$refs.dispatchModal.executar_chunck(
                "atendimentos",
                "terceiro_resultados_lote",
                datas,
                "",
                {},
                1
            );
        },

        final_chunk() {
            if (this.marcacoes.length > 0 && !this.stopChunkMarcacoes) {
                this.$nextTick(() => {
                    this.stopChunkMarcacoes = true;
                    this.$refs.dispatchModal.executar_chunck(
                        "atendimentos",
                        "terceiro_resultados_lote_marcacoes",
                        this.marcacoes,
                        "ids",
                        {
                            id_terceiro: this.id_terceiro,
                        },
                        2
                    );
                });
            } else {
                this.stopChunkMarcacoes = false;
                this.marcacoes = [];
                // this.$refs.dispatchModal.hide_modal();
            }
        },
        
        refresh_chunk(res) {
            console.log(res);
            if(res && res.ids) {
                this.marcacoes = this.marcacoes.concat(res.ids);
                return;
            }

            if(this.dados == null) 
                this.dados = res;
            else {
                console.log(this.dados);
                if(this.dados.resultados && res.resultados) {
                    this.dados.resultados = this.dados.resultados.concat(res.resultados);
                }
            }
            
            if (res && res.importado == false) {
                this.$toast.add({
                    severity: "error",
                    summary: "Integração laboratório",
                    detail: res.mensagem ? res.mensagem : res.msg,
                    life: 3000
                });
            } else if (res && res.importado == true) {
                this.$toast.add({
                    severity: "success",
                    summary: "Integração laboratório",
                    detail: res.mensagem ? res.mensagem : res.msg,
                    life: 3000
                });
            }
           
        }
    },

    mounted() {
        // this.agora = moment().format("YYYY-MM-DD HH:mm:ss");

        // this.tmaInterval = setInterval(() => {
        //     this.agora = moment().format("YYYY-MM-DD HH:mm:ss");
        // }, 1000 * 20);

        let query = {
            q: [
                {
                    name: "terceiros.lista",
                    id: "terceiros"
                }
            ]
        };
        this.$store.commit("loading", true);

        this.axios
            .post("/aql", query)
            .then(res => {
                if (res.data.terceiros.status == 200) {
                    this.terceiros = res.data.terceiros.data;
                }
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        this.$store.commit("setBreadcrumb", [
            { name: "Laboratório", path: "/laboratorio/visao" },
            { name: "Resultados", path: "/laboratorio/resultados-lote" }
        ]);
    }
};
</script>